(function($) {

    // functions 

    function enableTab(tab){
        tab.fadeIn('fast');
    }

    function disableTab(tab){
        tab.fadeOut('fast');
    }

    function changeCurrentTabName(tabname){
        var title = $('#tabs .tabs-heading .tab.type-content[data-tabname="' + tabname + '"]').find('.title-wrapper > strong').html();
        var subtitle;
        if($('#tabs .tabs-heading .tab.type-content[data-tabname="' + tabname + '"]').find('.title-wrapper > span').length > 0){
            subtitle = $('#tabs .tabs-heading .tab.type-content[data-tabname="' + tabname + '"]').find('.title-wrapper > span').html();
        }else{
            subtitle = '';
        }
        $('#tabs .filter-heading .current-tab strong').text(title);
        $('#tabs .filter-heading .current-tab span').text(subtitle);
    }

    function changeCurrentMenuItemTab(tabname){
        $('.nav-primary .nav > li.current-menu-item .sub-menu li').each(function(){
            if($(this).children('a').attr('href') === $(location).attr('href')){
                $(this).addClass('current-menu-item');
            }else{
                $(this).removeClass('current-menu-item');
            }
        });
    }

    function getTabNameInit(){
        var tabname;
        if(window.location.hash && $('#tabs .tabs-heading .tabs .tab.type-content[data-tabname="' + window.location.hash.substring(1) + '"]').length > 0 ){
            tabname = window.location.hash.substring(1);
        }else{
            tabname = $('#tabs .tabs > .type-content').first().data('tabname');
        }

        return tabname;
    }

    function initTab(){
        var tabname = getTabNameInit();
        changeCurrentTabName(tabname);
        changeCurrentMenuItemTab(tabname);
        if(!window.location.hash){
            history.replaceState({}, document.title, '#' + tabname );
        }
        $('#tabs .tabs-heading .tab.type-content[data-tabname="' + tabname + '"]').addClass('active');
        $('#tabs .tabs-content .tab').each(function(){
            disableTab($(this));
        });
        var first_tab = $('#tabs .tabs-content .tab[data-tabname="' + tabname + '"]');
        enableTab(first_tab);
    }

    function toggleTab(obj){
        var tabname = obj.data('tabname');
        // mobile current tab heading
        changeCurrentTabName(tabname);
        changeCurrentMenuItemTab(tabname);
        // url 
        history.replaceState({}, document.title, '#' + tabname );
        // tab content
        $('#tabs .tabs-content .tab').each(function(){
            if($(this).data('tabname') === tabname){
                enableTab($(this));
            }else{
                disableTab($(this));
            }
        });
        // tab heading
        $('#tabs .tabs-heading .tab.type-content').each(function(){
            if($(this).data('tabname') === tabname){
                $(this).addClass('active');
            }else{
                $(this).removeClass('active');
            }
        });
        // close filter section on mobile
        if($(window).width() < 769){
            $('#tabs .filter-heading').removeClass('opened');
            $('#tabs .filter-heading').next('.filters').slideUp('fast');
        }
    }


    $(document).ready(function(){

        // document ready

        if($('#tabs').length > 0){

            initTab();

            $(window).on('hashchange',function(){ 
                var tabname = location.hash.slice(1);
                toggleTab($('#tabs .tabs-heading .tab.type-content[data-tabname="' + tabname + '"]'));
            });

            $('#tabs .tabs-heading .tab.type-content').on('click' , function(e){
                e.preventDefault();
                toggleTab($(this));
            });

        }

    });
    
    
    })(jQuery);